module.exports = __webpack_public_path__ + "img/followbtn_on.b763c0d8.svg";